import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltActivityLogListDateGroupWireframe from './VeltActivityLogListDateGroupWireframe/VeltActivityLogListDateGroupWireframe';
import VeltActivityLogListItemWireframe from './VeltActivityLogListItemWireframe/VeltActivityLogListItemWireframe';
import VeltActivityLogListShowMoreWireframe from './VeltActivityLogListShowMoreWireframe/VeltActivityLogListShowMoreWireframe';
var VeltActivityLogListWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-activity-log-list-wireframe", __assign({}, transformedProps), children));
};
VeltActivityLogListWireframe.DateGroup = VeltActivityLogListDateGroupWireframe;
VeltActivityLogListWireframe.Item = VeltActivityLogListItemWireframe;
VeltActivityLogListWireframe.ShowMore = VeltActivityLogListShowMoreWireframe;
export default VeltActivityLogListWireframe;
